import {z} from 'zod'

//This enum comes from the import of the old system, it was a free text field, so we need to keep it as is
export const ServiceUoc = z.enum([
    'ADI',
    'Assistenza Domiciliare',
    'CAD',
    'Fisiatria',
    'MEDICIA RIABILITATIVA ASL RM1',
    'NEUROPSICHIATRIA GEMELLI',
    'NEUROPSICHIATRIA INFANTILE',
    'Ospedale Gemelli',
    'Policlinico Gemelli',
    'PUA',
    'Riabilitazione Ex Art. 26',
    'Roma 1 UOC Med. Riabilitativa',
    'SERVIZIO CAD',
    'SERVIZIO DISABILI ADUL',
    'SERVIZIO DISABILI ADULTI',
    'SERVIZIO FISIATRIA',
    'SERVIZIO GERIATRIA',
    'SERVIZIO NEUROLOGIA',
    'SERVIZIO NEUROPSICHIATRIA',
    'SERVIZIO ORTOPEDIA',
    'Servizio Disabili Adulti',
    'Servizio Fisiatria',
    'Servizio Malattie Infettive',
    'Servizio Neurologia',
    'Servizio Neurologia CAMPUS',
    'Servizio Neurologia Tor Vergata',
    'SERVIZIO FISIATRIA ASL RM3',
    'Servizio Ortopedia',
    'Servizio Riabilitazione',
    'Tor Vergata',
    'tsmree',
    'TSMREE',
    'TSMREEE',
    'UNITA CREEBROPATIE VASCOLARI',
    'Unità Cerebropatie Vascolari',
    'uoc',
    'UOC',
    'UOC ADI',
    'UOC CAD',
    'UOC Cura Intermedia',
    'UOC Disabili Adulti',
    'UOC Disabili Adulto',
    'UOC NEUROLOGIA',
    'UOC Neurologia',
    'UOC tsmree',
    'UOS',
    'UOS ADI',
    'UOS CURE DOMICILIARI',
    'UOS TSMREE',
    'UOS TUTELA SALUTE MENT',
    'UOSD Riabilitazione Neuromotoria',
    'DISABILI ADULTI'
])
export type ServiceUoc = z.infer<typeof ServiceUoc>

export const ReferringSpecialistTitle = z.enum(['dr_male', 'dr_female', 'prof_male', 'prof_female'])
export type ReferringSpecialistTitle = z.infer<typeof ReferringSpecialistTitle>

export const ReferringSpecialist = z.object({
    id: z.string().min(1),
    canBeDeleted: z.boolean(),
    firstName: z.string().min(1),
    lastName: z.string().min(1),
    serviceUoc: ServiceUoc,
    email: z.string().min(1).nullable(),
    createdAt: z.string().min(1),
    title: ReferringSpecialistTitle.nullish()
})
export type ReferringSpecialist = z.infer<typeof ReferringSpecialist>

export const ReferringSpecialistsColumn = z.enum(['fullName', 'serviceUoc', 'email', 'createdAt', 'moreActions'])
export type ReferringSpecialistsColumn = z.infer<typeof ReferringSpecialistsColumn>
